import * as Sentry from '@sentry/browser';

import _d from '@repperjs/debug';
import { getGPUInfo } from '@repperjs/shared/src/utils/environment/gpuInfo.ts';
import { getCurrentUser } from '@repperjs/shared/src/services/firebase/user/index.ts';

const NAMESPACE_WARNING = 'repper:warning';
const NAMESPACE_ERROR = 'repper:error';

// optionally enable sentry.io
if (process.env.PUBLIC_SENTRY_ENABLED === 'true') {
    _d('repper:logging')('Initializing sentry - remote logging enabled');
    Sentry.init({
        dsn: process.env.PUBLIC_SENTRY_DSN,
        release: `${process.env.PUBLIC_APP_VERSION}-${process.env.PUBLIC_GIT_REV}`,
    });
}

// prevent a message from being sent more than once in a row. Sentry and bugsnag won't be happy with this
// to do this, we store the last args as stringified JSON
let lastArgs = '';

// handler for debug messages
_d.onMessage = ({ namespace, args = [] }) => {
    // don't return anything other than warnings or errors
    if (namespace !== NAMESPACE_WARNING && namespace !== NAMESPACE_ERROR) return;

    if (lastArgs === JSON.stringify(args)) {
        // prevent additional sents
        return;
    }

    const error = args.find((arg) => arg instanceof Error);

    // store the last argument array
    lastArgs = JSON.stringify(args);

    if (process.env.PUBLIC_SENTRY_ENABLED === 'true') {
        let user;
        if (process.env.PUBLIC_LOG_USER_INFO === 'true') {
            const { uid, displayName, email } = getCurrentUser() || {};
            user = {
                id: uid,
                username: displayName,
                email,
            };
        }

        Sentry.withScope((scope) => {
            scope.setLevel(namespace === NAMESPACE_WARNING ? 'warning' : 'error');
            scope.setTags({ namespace, args: args.join(','), ...getGPUInfo() });
            user && scope.setUser(user);
            Sentry.captureException(error || new Error(args[0]));
        });
    }
};
